import BottomSheet from '@buncha/components/composites/bottomSheet';
import {Box} from '@buncha/components/core/view';
import DriverBarCodeEducationBody from './DriverBarCodeEducationBody';
import DriverBarCodeEducationHeader from './DriverBarCodeEducationHeader';
import React from 'react';
import {StyleSheet} from 'react-native';

interface DriverBarCodeEducationBottomsheetProps {
  open: boolean;
  onClose: () => void;
  onPress: () => void;
}

const DriverBarCodeEducationBottomsheet: React.FC<
  DriverBarCodeEducationBottomsheetProps
> = props => {
  return (
    <BottomSheet open={props?.open} onClose={props?.onClose}>
      <Box style={styles.parentBox}>
        <DriverBarCodeEducationHeader />
        <DriverBarCodeEducationBody onPress={props?.onPress} />
      </Box>
    </BottomSheet>
  );
};

export default React.memo(DriverBarCodeEducationBottomsheet);

const styles = StyleSheet.create({
  parentBox: {
    padding: 15,
    gap: 15,
  },
});
